import { Message, IMessage, MessageTextConverter } from "./Message";
import { useState, useContext, useEffect } from "react";
import {  Offcanvas } from "bootstrap";
import { AppContext } from '../ApplicationContext';

export interface IListMessage extends IMessage {

    Header: string;
    Footer: string;
    Body : string;
    ListHeader: string;
    SubmitButton: string;
    Items:IListMessageItem[];
}

export interface IListMessageItem {
    Title: string;
    Description: string;
    SectionTitle: string;
    Id: string;
}

export const ListMessage = (props:IListMessage) => {

    const [done, setDone] = useState(props.Valid);

    const context = useContext(AppContext);

    const [list , setList] = useState(null); 
    
    useEffect(()=> {
    setTimeout(()=> {
        setList(new Offcanvas('#list-' + props.Identifier));
    },50)
    },[]);
    
    console.log("list",{list:list});

     
    const onShowList = (e) => {
    
        
        list.show();

    }

    const onChoose = async (item: IListMessageItem) => {
    

       //const list = new Offcanvas('#list-' + props.Identifier)
        list.hide();

       

        
        try {

            //context.connection.invoke("SendListItem", item).then((result)=>{console.log('SendListItem done', result)}, (err)=> {console.log({error:err})});

            await context.messenger.sendListItem(item);

            setDone(true);

        } catch (err) {
            console.error(err);
        }

    }

     

    return <> <Message {...props}>
                {props.Header && props.Header  !== "" && <div className="row header">
                 <div className="col">
                    {MessageTextConverter.parse(props.Header)}
                </div> 
                </div>
                }
                {props.Body && props.Body  !== "" && <div className="row body">
                 <div className="col">
                    {MessageTextConverter.parse(props.Body)}
                </div> 
                </div>
                }

                { (!done) && <div className="row submitbutton text-center">
                    <div className="col">
                        <button className="btn btn-light" onClick={ onShowList } >{MessageTextConverter.parse(props.SubmitButton)}</button>
                    </div>
                    
                </div>
                }

                {props.Footer && props.Footer  !== "" && <div className="row footer">
                 <div className="col">
                    {MessageTextConverter.parse(props.Footer)}
                     </div>
                </div>
                }

            </Message>

            <div className="offcanvas offcanvas-bottom list-message-list" tabIndex={-1} id={"list-" + props.Identifier} aria-labelledby={"list-title-" + props.Identifier}>
              <div className="offcanvas-header">
              <div className="container">

                    <h5 className="offcanvas-title" id={"list-title-" + props.Identifier}>{MessageTextConverter.parse(props.ListHeader)}</h5>
                    
              </div>
                
              </div>
              <div className="offcanvas-body">
              <div className="container miles-research-dialogs-listmessage-list">
               <div className="list-group list-group-flush">

                  { props.Items["$values"].map((item, idx) => <>
                  
                    <button type="button" className="list-group-item list-group-item-action" onClick={async (e)=> await onChoose(item)}>  

                    {item.Title && item.Title !== "" && <div className="d-flex w-100 justify-content-between">
                            <h6 className="mb-1">{MessageTextConverter.parse(item.Title)}</h6>
                            
                        </div>
                        }
                        { item.Description && item.Description !== "" && <p className="mb-1">{MessageTextConverter.parse(item.Description)}</p>}
                        { item.SectionTitle && item.SectionTitle !== "" && <small className="text-muted">{MessageTextConverter.parse(item.SectionTitle)}</small>}
                        </button> 
                  </>) }
                  
                </div>
                </div>
              </div>
            </div>

            </>

}